import { AnimatePresence, motion } from 'framer-motion'

type Props = {
    transitionKey: any
    className?: string
    children: React.ReactNode
}

export default function Transition(props: Props) {

    const { transitionKey, className, children } = props
    return (
        <AnimatePresence initial={true}>
            <div className={className}>
                <motion.div
                    className="full"
                    key={transitionKey}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ type: "ease-in-out", duration: 0.5 }}
                >
                    {children}
                </motion.div>
            </div>
        </AnimatePresence>
    )
}